const testReportRouter = [
    {
        path:'',
        name:'testReports-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/testReport/index.vue'),
        children:[
            {
                path:'',
                name:'testReports-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視物種分類 或 點選新增物種分類' }
            },
        ]
    },
    
  ]
  export default testReportRouter